import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { usePermissions, ModuleKey } from '@/hooks/usePermissions';
import { toast } from 'sonner';
import { PageErrorBoundary } from '@/components/PageErrorBoundary';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredModule?: ModuleKey | string;
  /** Basta o módulo estar habilitado em alguma empresa da pessoa (agenda única), não só na ativa. */
  moduleInAnyEmpresa?: boolean;
}

export function ProtectedRoute({ children, requiredModule, moduleInAnyEmpresa = false }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading } = useAuth();
  const { hasPermission, hasPermissionInAnyEmpresa } = usePermissions();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="animate-spin h-8 w-8 border-2 border-primary border-t-transparent rounded-full" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Verificar se o módulo está habilitado
  const moduloHabilitado = moduleInAnyEmpresa ? hasPermissionInAnyEmpresa : hasPermission;
  if (requiredModule && !moduloHabilitado(requiredModule)) {
    // Redirecionar para dashboard com aviso
    toast.error(`O módulo "${requiredModule}" não está habilitado para sua empresa.`);
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <PageErrorBoundary key={location.pathname}>
      {children}
    </PageErrorBoundary>
  );
}
